import { render, staticRenderFns } from "./CurrentQuiz.vue?vue&type=template&id=6f361fc5&scoped=true"
import script from "./CurrentQuiz.vue?vue&type=script&lang=js"
export * from "./CurrentQuiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f361fc5",
  null
  
)

export default component.exports